module.exports = __webpack_public_path__ + "img/IT0000207618473.a62f5b00.png";